import Konva from 'konva';
import GraphicBase from './base';
import * as WalkingLadderUrl from '../assets/i1.png';
import * as ScreenUrl from '../assets/i2.png';
import * as JunctionUrl from '../assets/i3.png';
import * as AreaCenterUrl from '../assets/i4.png';
import * as CrossroadsUrl from '../assets/i5.png';
import * as ElevatorUrl from '../assets/i6.png';
import * as EscalatorUrl from '../assets/i7.png';

class GraphicPoint extends GraphicBase {
  constructor(payload, stage) {
    super(payload, stage);

    this.canDraggable = true;
  }

  build() {
    const { data, id, stage } = this;
    this.strokeColor = '#808080';
    let image = false;
    if (this.group_type === 'Elevator') {
      image = ElevatorUrl;
    }
    if (this.group_type === 'Escalator') {
      image = EscalatorUrl;
    }
    if (this.group_type === 'Screen') {
      image = ScreenUrl;
    }
    if (this.group_type === 'WalkingLadder') {
      image = WalkingLadderUrl;
    }
    if (this.group_type === 'Crossroads') {
      image = CrossroadsUrl;
    }
    if (this.group_type === 'Junction') {
      image = JunctionUrl;
    }
    if (this.group_type === 'AreaCenter') {
      image = AreaCenterUrl;
    }

    const p = stage.pointDict[data[0]];
    if (!p) return null;
    if (image) {
      const imageObj = new Image();
      imageObj.src = image;

      const width = 15;

      this.ele = new Konva.Image({
        id,
        image: imageObj,
        pid: data[0],
        width,
        height: width,
        isPoint: true,
        x: p.x,
        y: p.y,
        opacity: 1,
        offsetX: width / 2,
        offsetY: width / 2,
      });
    } else {
      this.ele = new Konva.Circle({
        id,
        pid: data[0],
        x: p.x,
        y: p.y,
        isPoint: true,
        radius: 3,
        stroke: this.strokeColor,
        fill: 'white',
        strokeWidth: 3,
      });
    }

    this.ele.on('dragstart', (e) => {
      stage.pointDragStartHandler(e);
    });

    this.ele.on('dragend', (e) => {
      stage.pointDragEndHandler(e);
    });

    this.ele.on('dragmove', (e) => {
      stage.pointDragHandler(e);
    });

    this.ele.on('click', (e) => {
      stage.pointClickHandler(e);
    });

    stage.pointLayer.add(this.ele);
    this.layer = stage.pointLayer;

    this.updateText();

    this.ele.graphic = this;
    if (this.property.screen_end) {
      // 终点
      this.strokeColor = 'Purple';
      this.ele.stroke(this.strokeColor);
    } else if (this.property.screen_direction_pos) {
      // 大屏朝向点绑定
      this.strokeColor = 'green';
      this.ele.stroke(this.strokeColor);
    } else if (this.property.screen_pointer) {
      // 大屏拐角标识绑定
      this.strokeColor = 'yellow';
      this.ele.stroke(this.strokeColor);
    }
    return this.ele;
  }

  setSelected(selected) {
    if (this.group_type === 'LinePoint') {
      if (selected) {
        this.ele.stroke('#FF3B30');
      } else {
        this.ele.stroke(this.strokeColor);
      }
    }
  }

  updateText() {
    // 绑定了属性名字的
    if (this.property && this.property.name) {
      // 获取点
      const p = this.stage.pointDict[this.data[0]];

      // 不存在创建
      if (!this.text) {
        this.text = new Konva.Text({
          fontSize: 4,
          fill: '#ff0000',
          width: 30,
          height: 4,
        });
        this.stage.textLayer.add(this.text);
      }

      // 修改对应属性
      this.text.text(this.property.name);
      this.text.x(p.x - this.text.textWidth / 2);
      this.text.y(p.y - this.text.textHeight / 2 - 6);
    } else if (this.text) { // 以前绑定属性名字 现在不绑定的需要删除
      this.text.remove();
      this.text = null;
    }
  }
}

export default GraphicPoint;
